export default __webpack_public_path__ + "c28e863a64986c121bfbc89024aea5c9.png";